import { render, staticRenderFns } from "./IconButtonTooltip.vue?vue&type=template&id=65f12856&scoped=true"
import script from "./IconButtonTooltip.vue?vue&type=script&lang=js"
export * from "./IconButtonTooltip.vue?vue&type=script&lang=js"
import style0 from "./IconButtonTooltip.vue?vue&type=style&index=0&id=65f12856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f12856",
  null
  
)

export default component.exports